// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".active-branch[data-v-2e2dae55]{color:#f7f9fd!important;font-weight:800;font-size:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
